<div class="row cg-margin-bottom-lg">
  <div class="col-xs-12 col-sm-6 col-md-3">
    <h2 class="cg-margin-bottom-md cg-callout-header">
      {{ 'login.cignaResources.newsTitle' | translate }}
    </h2>
  </div>
  <div class="col-xs-12 col-lg-9 content">
    Read our current newsletters for
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.cigna.com/health-care-providers/resources/newsletters/network-news"
      [cignaTrackClicks]="[
        'trackEventOther',
        'Medical',
        'ac-Login019-US1023777-Medical Read',
        { prop20: 'Latest News' }
      ]"
      >Medical</a
    >,
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.cigna.com/the-bridge/"
      [cignaTrackClicks]="[
        'trackEventOther',
        'Dental',
        'ac-Login020-US1023777-Dental Read',
        { prop20: 'Latest News' }
      ]"
      >Dental</a
    >
    or
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.cigna.com/transformations/"
      [cignaTrackClicks]="[
        'trackEventOther',
        'Behavioral',
        'ac-Login021-US1023777-Behavioral Read',
        { prop20: 'Latest News' }
      ]"
      >Behavioral</a
    >
    providers.
  </div>
</div>
<div class="row">
  <div class="col-xs-12 col-sm-6 col-md-3">
    <h2 class="cg-margin-bottom-md cg-callout-header">
      {{ 'login.cignaResources.findCareTitle' | translate }}
    </h2>
  </div>
  <div class="col-xs-12 col-lg-9 content">
    <a
      target="_blank"
      rel="noopener noreferrer"
      href="https://www.cigna.com/hcpdirectory"
      [cignaTrackClicks]="[
        'trackEventOther',
        'Find a health care professional',
        'ac-Login008-US1023762-Find Professional'
      ]"
      >Find a health care professional</a
    >
    in your patients’ network. Select a directory, and find network
    participating health care professionals that best fit your patients’ needs,
    based on their coverage.
  </div>
</div>
